<template>
  <v-dialog
    v-model="planDialog"
    width="300px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span >Enter Policy No.</span>
          <i
            class="el-icon-close"
            @click="planDialog=false"></i>
        </div>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          class="form-container"
          :model="formData">
          <div class="flex-content">
            <div class="flex-box">
              <div
                class="flex-info ">
                <span >
                  Policy No.
                </span>
                <el-form-item prop="pcy_no">
                  <v-input v-model="formData.pcy_no"></v-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="flex footer-button">
        <v-button @click="planDialog=false">Cancel</v-button>
        <v-button
          type="success"
          @click="ConfirmCoupon">Next</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'

export default {
  name: 'AddDollarDialog',
  mixins: [MixinOptions, MixinFormat,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId:{
      type:[String,Number],
      default:''
    },
  },
  data() {
    return {
      planDialog: false,
      formData:{
        pcy_no:''
      }
    }
  },
  computed:{
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        console.log('-form',val)
        let {pcy_no} = val||{}
        if(pcy_no)
          this.formData.pcy_no = pcy_no
      }
    }
  },
  methods: {
    changeDialog(data) {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.planDialog = false
          this.$emit('setVoid',this.formData.pcy_no)
        }
      })

    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;

  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;

      i {
        font-weight: 600;
        font-size: 14px;
      }
    }
  }

  .title-span {
    color: #24292E;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .dialog-body {
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }

  .footer-button {
    padding: 15px;
    justify-content: space-between;
  }

  .tip {
    color: #586069;
    font-weight: 500;
  }

  .flex-content {
    //width: 280px;
    .padding {
      padding: 10px;
    }

    .flex-box {
      //border-radius: 5px;
      //border: 1px solid #E1E4E8;
      //width: 280px;
      //margin: 16px 0;

      .flex-info {
        display: flex;
        flex-direction: column;
        //padding: 23px 15px;
        //border-bottom: 1px solid #E1E4E8;

        span {
          color: #24292E;
          font-size: 14px;
          margin-bottom: 15px;
          font-weight: 500;
        }

      }

      .coupon-button {
        .el-button {
          width: 100%;
        }

        .margin-right {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>